export enum ArticleEnums {
  //Tipo:
  todos = 1,
  entradas = 2,
  facturas = 3,
  notas = 4,
  reparaciones = 5,
  salidas = 6,
  byCompany = 7,
  orders = 8,

  //Tipo ventana
  article = 0,
  articleGeneric = 1,

  //Estado
  activo = 1,


  //Tipos:
  tipoEquipo = 1,
  tipoInsumo = 2,
  tipoReparación = 3,
  tipoAccesorio = 4,
  tipoServicio = 5,
  tipoOtro = 6,
}